import { axiosInstance } from "../axios-client/axiosClient";

export const validateDiscountCall = async (data) => {
    const api = axiosInstance();
    return await api.post("/api/discount/validate-discount", data);
};